/*
 *                     NOTICE
 *            COPYRIGHT 2020 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import * as React from "react";

/** The global react context object used for the Ab consolidated context.
 * The context holds an object with properties for each individual context service or data.
 * It is not strongly typed here to limit dependencies. Otherwise this would bring in every context service and data.
 *
 * The default context value is an empty object, so that the value of this.context should not be undefined, simplifying usage.
 *
 * To use this context within your React component:
 *
 *   import {AbReactContext} from "abreact/incubator/context/AbContextComponentFactories";
 *   export class MyComponent extends React.Component<MyComponentProps> {
 *     static contextType = AbReactContext;
 *     context: IExclusiveEditCoordinatorContext;   // type it to get the services or data you wish. Can | to include more services.
 *     render() {
 *       this.context.exclusiveEditCoordinator...
 *     }
 */
export const AbReactContext = /*#__PURE__*/React.createContext({});
//# sourceMappingURL=AbReactContext.js.map
